// utiliy
import Cookies from "js-cookie";

export const getRememberedUsers = () => {
	try {
		const cookieData = Cookies.get("rememberedUsers");
		return cookieData ? JSON.parse(cookieData) : [];
	} catch (error) {
		console.error("Error parsing remembered users cookie:", error);
		return [];
	}
}

export const setRememberedUsers = (users) => {
  try {
    Cookies.set("rememberedUsers", JSON.stringify(users), {
      expires: 30,
      sameSite: "strict",
      secure: window.location.protocol === "https:",
    });
  } catch (error) {
    console.error("Error saving remembered users cookie:", error);
  }
};

export const clearRememberedUsers = () => {
  Cookies.remove("rememberedUsers");
};